/**
 * Utility functions for date formatting and cancellation logic
 */

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // If the string looks like an ISO date but lacks 'Z', add it to force UTC interpretation
    let isoStr = dateStr;
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(dateStr)) {
      isoStr = dateStr + 'Z';
    }
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return '';
    const formatted = d.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: userTimeZone
    });
    return formatted;
  } catch (error) {
    console.error('Error formatting datetime:', error);
    return '';
  }
};

export const isCancelable = (row, now, thresholdMs = 0) => {
  if (!row) return false;
  if (String(row.callStatus || row.status || '').toLowerCase() !== 'scheduled') return false;
  if (!row.cancelBefore) return false;
  try {
    const deadline = new Date(row.cancelBefore);
    if (Number.isNaN(deadline.getTime())) return false;
    const remaining = deadline.getTime() - now;
    if (remaining <= 0) return false;
    if (remaining < thresholdMs) return false;
    return true;
  } catch (e) {
    return false;
  }
};